<template>
  <div v-if="show" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg p-8 w-full max-w-md mx-4">
      <div class="text-center mb-6">
        <h2 class="text-2xl font-bold text-slate-900">
          Login
        </h2>
        <p class="text-slate-600 mt-2">
          Sign in to continue
        </p>
      </div>

      <!-- Error Message -->
      <div v-if="error" class="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
        {{ error }}
      </div>

      <form @submit.prevent="handleSubmit" class="space-y-4">


        <!-- Email field -->
        <div>
          <label for="email" class="block text-sm font-medium text-slate-700 mb-1">
            Email
          </label>
          <input
            id="email"
            v-model="form.email"
            type="email"
            required
            class="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter email"
          />
        </div>

        <!-- Password field -->
        <div>
          <label for="password" class="block text-sm font-medium text-slate-700 mb-1">
            Password
          </label>
          <input
            id="password"
            v-model="form.password"
            type="password"
            required
            class="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter password"
          />
        </div>

        <!-- Submit button -->
        <button
          type="submit"
          :disabled="loading"
          class="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white font-medium py-2 px-4 rounded-md transition duration-200"
        >
          <span v-if="loading" class="flex items-center justify-center">
            <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
            Signing in...
          </span>
          <span v-else>
            Sign In
          </span>
        </button>
      </form>

      <!-- Contact admin message -->
      <div class="mt-6 text-center">
        <p class="text-slate-500 text-sm">
          Need an account? Contact your administrator.
        </p>
      </div>

      <!-- Close button -->
      <button
        @click="$emit('close')"
        class="absolute top-4 right-4 text-slate-400 hover:text-slate-600"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'LoginModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        email: '',
        password: ''
      }
    };
  },
  computed: {
    ...mapGetters('auth', ['authLoading', 'authError']),
    loading() {
      return this.authLoading;
    },
    error() {
      return this.authError;
    }
  },
  methods: {
    ...mapActions('auth', ['login', 'clearError']),
    
    async handleSubmit() {
      try {
        await this.login({
          email: this.form.email,
          password: this.form.password
        });
        
        // Success - close modal and emit success event
        this.$emit('success');
        this.resetForm();
      } catch (error) {
        // Error is handled by the store
        console.error('Auth error:', error);
      }
    },
    
    resetForm() {
      this.form = {
        email: '',
        password: ''
      };
    }
  },
  
  watch: {
    show(newVal) {
      if (newVal) {
        this.clearError();
        this.resetForm();
      }
    }
  }
};
</script> 